"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PowerBy500px = exports.CopyRightBox = exports.FooterBox = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _MediaQueries = _interopRequireDefault(require("../../../../../MediaQueries"));

var _StyledLayout = require("../../../../../StyledLayout");

var _StyledTypography = require("../../../../../StyledTypography");

var _templateObject;

var FooterBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__FooterBox",
  componentId: "v9y8xq-0"
})(["background:", ";svg{path{fill:", ";}}"], function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  return props.theme.portfolioForeground1;
});
exports.FooterBox = FooterBox;
var CopyRightBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__CopyRightBox",
  componentId: "v9y8xq-1"
})(["margin-top:120px;display:flex;align-items:center;flex-direction:column;padding-left:", ";padding-right:", ";padding-bottom:", ";@media(min-width:667px){padding-left:48px;padding-right:48px;}", " a{&:hover{color:", " font-weight:bold;}}@media (max-width:", "px){padding:0;}"], function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.theme.spacingMd;
}, _MediaQueries["default"].minWidth.medium(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    flex-direction: row;\n    justify-content: space-between;\n  "]))), function (props) {
  return props.theme[props.colour];
}, function (props) {
  return props.theme.responsiveSmall;
});
exports.CopyRightBox = CopyRightBox;
var PowerBy500px = (0, _styledComponents["default"])(_StyledTypography.Caption).withConfig({
  displayName: "Elements__PowerBy500px",
  componentId: "v9y8xq-2"
})(["display:inline-block;"]);
exports.PowerBy500px = PowerBy500px;